import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faDumbbell } from '@fortawesome/free-solid-svg-icons';

import ActivitySessionTable from '@activities/components/tables/activity-session-table/activity-session-table.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { v4 as uuidv4 } from 'uuid';
import GenerateSessionsByTimeSlotsModal from '@activities/components/modals/generate-sessions-by-time-slots-modal/generate-sessions-by-time-slots-modal.vue';

library.add(faDumbbell);

@Component({
  name: 'bpc-activity-session-container',
  components: {
    'bpc-activity-session-table': ActivitySessionTable,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-generate-session-by-time-slots-modal': GenerateSessionsByTimeSlotsModal,
  },
})
export default class ActivitySessionContainer extends Vue {
  $refs: {
    activitySessionTable: InstanceType<typeof ActivitySessionTable> & {
      setStdFormData(index, value): void;
      onPageAction(event): void;
      onRefresh(): void;
    };
  };

  @Prop(Object) readonly activityFormModel: AnyEntity;
  @Prop(Object) readonly groupFormModel: AnyEntity;
  @Prop({ type: Boolean }) readonly isLoading: boolean;
  @Prop({ type: String, default: 'create-from-management' }) readonly formConfigName: string;
  @Prop({ type: String, default: 'management-table' }) readonly displayConfigName: string;
  @Prop({ type: String, default: 'edit' }) readonly editFormConfigName: string;
  @Prop({ type: Boolean, default: true }) readonly showTitle: boolean;
  @Prop({ type: Array, default: null }) readonly selectConfigName: string[];
  @Prop({ type: String, default: 'management' }) readonly filterConfigName: string;
  @Prop({ type: Boolean, default: false }) readonly showExtendedFilters: boolean;

  //DATA

  public activitySessionTableKey: string = 'activity-session-table-';

  public filtersExcluded = ['activity_id'];
  public bulkEditFormConfigName: string = 'bulk-edit';
  showGenerateSessionsModal: boolean = false;
  public userIsResponsibleOfGroup: boolean = false;

  // LIFECYCLE

  mounted() {
    this.checkResponsible();
  }

  // COMPUTED
  get activityGroupId() {
    return this.groupFormModel?.id;
  }

  get activityGroupTimeSlots() {
    return this.groupFormModel?.time_slots;
  }

  get activityType() {
    return this.activityFormModel?.activity_type;
  }

  // METHODS

  async checkResponsible() {
    if (
      !this.$authorizationService.hasPermission('manage_activity_sessions') &&
      this.$authorizationService.hasPermission('manage_own_activity_sessions')
    ) {
      const basePath = this.$bpcApiRouteHelper.getEntityPath('activity-group');
      const path = `${basePath}/${this.activityGroupId}`;
      const res = await this.$bpcApi.get(path).toPromise();
      const groupResponsibles = res.data['contacts'];
      const userId = this.$authorizationService.getContactId();
      const result = !!groupResponsibles.find(contact => contact.id === userId);
      this.userIsResponsibleOfGroup = result;
    } else {
      this.userIsResponsibleOfGroup = true;
    }
  }
  onCreateActivitySession() {
    this.$refs.activitySessionTable.onPageAction('create');
  }

  onModelLoaded($event) {
    //When the model is loaded we have to load by default he activity and the group on management.
    this.$refs.activitySessionTable.setStdFormData('activity_id', this.activityFormModel.id);
    this.$refs.activitySessionTable.setStdFormData('activity', this.activityFormModel);
    this.$refs.activitySessionTable.setStdFormData('activity_group_id', this.groupFormModel.id);
    this.$refs.activitySessionTable.setStdFormData('activityGroup', this.groupFormModel);
  }

  clickOnGenerateSessions() {
    this.showGenerateSessionsModal = true;
  }

  onCloseGenerateSessionsModal() {
    this.showGenerateSessionsModal = false;
  }

  onGeneratedSessions() {
    this.$refs.activitySessionTable.onRefresh();
  }

  refreshSessionsTable() {
    this.$refs.activitySessionTable.onRefresh();
  }

  // WATCHERS
  //TODO: discuss about the best way to refresh table on route change or on model change.

  /*
  @Watch('$route')
  onChangeRoute() {
    setTimeout(() => {
      if (this.$refs.activitySessionTable) {
        this.$refs.activitySessionTable.onRefresh();
      }
    });
  }
*/

  @Watch('activityGroupId')
  onGroupChanged() {
    if (this.$refs.activitySessionTable) {
      this.$refs.activitySessionTable.onRefresh();
    }
  }
}
